// extracted by mini-css-extract-plugin
module.exports = {"main":"EditHelpMessage_main__iBy1M","body":"EditHelpMessage_body__1flRA","messageBox":"EditHelpMessage_messageBox__1FQVW","actionBtn":"EditHelpMessage_actionBtn__20bD6"};